import { ReactComponent as BulletTick } from '../images/bullet-tick.svg'
import React, { useEffect, useState, useCallback } from 'react'
import PrimaryButton from './components/Button/PrimaryButton'
import { parseSvgToJsx } from './stickee-widget/utils/svg-parser.util.jsx'
import {
  SvgLogo,
  StyledLandingScreen,
  LogoContainer
} from './LandingScreen.style'
import { useGetWhiteLabelLogoQuery } from '../broadband/white-labeling.api.js'
import { ReactComponent as YoutilityLogo } from '../images/yt-logo.svg'

export const LandingScreen = props => {
  const { title, description, bullets, action, actionLabel, isLoading } = props
  const queryParameters = new URLSearchParams(window.location.search)
  const whiteLabelClientId = queryParameters.get('utm_source')
  const getTypeFromPath = () => {
    const path = location?.pathname || ''
    if (path.startsWith('/mobile')) return 'mobile'
    if (path.startsWith('/broadband')) return 'broadband'
    return 'broadband' // default to broadband if no match
  }
  const { data: whiteLabelLogoSvg } = useGetWhiteLabelLogoQuery(
    {
      clientId: whiteLabelClientId,
      type: getTypeFromPath()
    },
    {
      skip: !whiteLabelClientId
    }
  )

  const getPartnersLogo = useCallback(() => {
    if (whiteLabelLogoSvg) {
      const jsxSvg = parseSvgToJsx(whiteLabelLogoSvg)
      setWhiteLabelLogo(jsxSvg)
    }
  }, [whiteLabelLogoSvg])
  useEffect(() => {
    if (whiteLabelClientId) {
      getPartnersLogo()
    }
  }, [getPartnersLogo, whiteLabelClientId])
  const [whiteLabelLogo, setWhiteLabelLogo] = useState(null)

  return (
    <StyledLandingScreen
      data-testid={'LandingPageBlock'}
      className="landingPage desktopLayout"
    >
      <main className="innerSection">
        <LogoContainer>
          {whiteLabelLogo && <SvgLogo>{whiteLabelLogo}</SvgLogo>}
          {whiteLabelLogo && (
            <div
              style={{
                height: '30px',
                borderLeft: '1px solid #D1D5DB'
              }}
            />
          )}
          <SvgLogo>
            <YoutilityLogo />
          </SvgLogo>
        </LogoContainer>
        <div role="heading" aria-level="1">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        <div className="bulletList">
          <ul>
            {bullets.map((listData, index) => (
              <li key={index}>
                <BulletTick className="svgStrokeColor" />
                <span>{listData}</span>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <footer role="contentinfo" className="footer-container">
        <PrimaryButton
          data-testid={'LandingPageSubmitButton'}
          onClick={action}
          loading={isLoading ? 1 : 0}
        >
          {actionLabel}
        </PrimaryButton>
        <div className="footerLink">
          We use <a href="https://youtility.co.uk/cookie-policy">cookies</a> to
          enhance your experience, by continuing you agree to their use.
        </div>
      </footer>
    </StyledLandingScreen>
  )
}
